// removed by extract-text-webpack-plugin
module.exports = {"img":"qmgux2bebddgz469yf11u6catn2v9cf5vmc25djnh2npcaagjcmc6jnh6sffzh6xzzsw5aggmvb8ruxm8g2wxy6ab8ud2y236jsk9z-CarouselItem-module-img"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CarouselItem/CarouselItem.module.scss
// module id = 545
// module chunks = 0